import Cookies from 'js-cookie'

const TokenKey:string = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
  // return "11";
  //return true;
}

export function setToken(token:string) {
  return Cookies.set(TokenKey, token)

  // return "11";
}

export function removeToken() {
  return Cookies.remove(TokenKey)

  // return "11";
}
